import { ChartPoint } from "../chart/ChartPoint";
import { DataPointResponse } from "../contracts/DataPointResponse";
import { ProjectResponse } from "../contracts/ProjectResponse";
import { Project } from "./Project";

export class ProjectResponseMapper {
  mapProjectResponseToProject = (projectResponse: ProjectResponse): Project => {
    return {
      id: projectResponse.id,
      name: projectResponse.name,
      milestones: projectResponse.milestones.map((milestone) => ({
        id: milestone.id,
        name: milestone.name,
        estimateChartLines: {
          totalEstimate: this.sortChartPoints(milestone.totalEstimate),
          actualBurnUp: this.sortChartPoints(milestone.actualBurnup),
          estimateBurnUp: this.sortChartPoints(milestone.estimateBurnup),
          estimatedTotalHoursNeeded: this.sortChartPoints(
            milestone.estimatedTotalHoursNeeded
          ),
          totalTaskEstimates: this.sortChartPoints(
            milestone.totalTaskEstimates
          ),
          totalOfEstimatedCompleted: this.sortChartPoints(
            milestone.totalOfEstimatedCompleted
          ),
          totalTasks: this.sortChartPoints(milestone.totalTasks),
        },
        gitLabCreateDate: milestone.gitLabCreateDate,
      })),
    };
  };

  sortChartPoints = (points: DataPointResponse[]): ChartPoint[] => {
    return points.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );
  };
}
